import { CustomRangeSlider, Heading } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { kwToPs } from "../../helpers/KwToPs";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";
import { getMaxPower, getMinPower } from "../../data/contract";
import { BrandType } from "@bus/models";

export const Power = () => {
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const { t } = useTranslation(["question3page"]);
    const { values, setFieldValue } = useFormikContext<IMatchMakerAnswers>();
    const handleOnChange = (values: number[]) => {
        setFieldValue("minPower", values[0]);
        setFieldValue("maxPower", values[1]);
    };
    
    const getTitle = () => {
        switch (brand) {
            case BrandType.VW:
                return t("question3page:power.titleVW");
            case BrandType.AUDI:
                return t("question3page:power.titleAudi")
            default:
                return t("question3page:power.title");
        }
    }
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{getTitle()}</Heading>
            <CustomRangeSlider
                range={{
                    min: getMinPower(),
                    max: getMaxPower(),
                }}
                onSet={(values: string | number | (string | number)[]) => {
                    handleOnChange((values as number[]).map((v) => Math.round(v)));
                }}
                value={[values.minPower || getMinPower(), values.maxPower || getMaxPower()]}
                connect={[false, true, false]}
                step={10}
                tooltips={{
                    to: (e: number) => e.toFixed(0) + `KW (${kwToPs(e).toFixed(0)} CV)`,
                }}
                className="u-mr-large@s u-ml-large@s"
            />
        </>
    );
};
